import { Device } from '../Device'

export default function isBelowViewport({
  selector,
  insertPosition,
  mobileInsertPosition
}: ISlotModel): boolean {
  const viewportHeight = window.innerHeight
  const element =
    selector instanceof Element
      ? selector
      : (document.querySelector(selector) as Element)

  if (!element) {
    return false
  }

  const { top, height } = element.getBoundingClientRect()
  const position = Device.isMobileOrTablet
    ? mobileInsertPosition
    : insertPosition

  const totalDistanceFromViewport =
    position === 'beforebegin' || position === 'afterbegin' ? top : top + height

  return totalDistanceFromViewport > viewportHeight
}
